// extracted by mini-css-extract-plugin
module.exports = {"icon":"_23675","text":"_3nKfr","button":"_2raSe"};